import { Component } from '@angular/core';
import { setItem } from '@app/_shared/utils/storage';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'BHDL_LandingPage_Tarjeta';

  constructor() {
    const { apiUrl, vuKey } = environment;
    setItem('api', apiUrl);
    setItem('vuKey', vuKey);
  }
}
